export default [
  {
    path: 'requirements',
    component: () => import('./MenuRequirements'),
    children: [
      {
        path: '/',
        component: () => import('./MenuRequirementsList'),
        name: 'menuRequirements'
      },
      {
        path: 'add',
        component: () => import('./RequirementForm'),
        name: 'addRequirement'
      },
      {
        path: ':id/edit',
        component: () => import('./RequirementForm'),
        name: 'editRequirement'
      }
    ]
  }
]
